import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import bassLogoAscii from 'constants/bassLogoAscii';
import { taglineForLanguage } from 'constants/taglines';
import AudioRentalWaves from 'components/AudioRentalWaves';
import NavHashLink from 'components/NavHashLink';
import { scrollToTop } from 'utils/scrollToSection';

function Header() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const currentLang = i18n.resolvedLanguage || i18n.language;
  const tagline = taglineForLanguage(currentLang);

  const handleLogoClick = (event) => {
    event.preventDefault();

    if (location.pathname !== '/') {
      navigate('/');
    } else if (location.hash) {
      navigate({ pathname: '/', hash: '' }, { replace: true });
    }

    scrollToTop();
  };

  return (
    <nav className="site-nav">
      <div className="nav-inner">
        <Link to="/" className="nav-logo" aria-label="BASS — home" onClick={handleLogoClick}>
          <div className="logo-mark">
            <pre className="logo-ascii" aria-hidden="true">{bassLogoAscii}</pre>
            <div className="logo-tagline">
              <AudioRentalWaves tagline={tagline} />
            </div>
          </div>
        </Link>
        <ul className="nav-links">
          <li><NavHashLink to="/#categories">{t('nav.gear')}</NavHashLink></li>
          <li><NavHashLink to="/#featured">{t('nav.catalog')}</NavHashLink></li>
          <li><NavHashLink to="/#process">{t('nav.process')}</NavHashLink></li>
          <li><NavHashLink to="/#contact">{t('nav.contact')}</NavHashLink></li>
        </ul>
        <div className="nav-actions">
          <NavHashLink to="/#contact" className="nav-cta">{t('nav.enquire')}</NavHashLink>
          <div className="lang-switch" role="group" aria-label="Language">
            {['pl', 'en'].map((lang) => (
              <button
                key={lang}
                type="button"
                className={`lang-switch__btn${currentLang.startsWith(lang) ? ' lang-switch__btn--active' : ''}`}
                aria-pressed={currentLang.startsWith(lang)}
                onClick={() => i18n.changeLanguage(lang)}
              >
                {lang.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header;
